import React from 'react';
import '../App.css';
import "animate.css/animate.min.css";
import ScrollAnimation from 'react-animate-on-scroll';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

AOS.init();

export default class AboutUs extends React.Component {

    render() {
        const testimonialsData = [
            {
                text: "Working with Shree Jeen Interiors has been a seamless and satisfying experience. Neeraj and his team bring a rare blend of traditional craftsmanship and modern execution skills. They understand the pulse of retail interiors and always deliver beyond expectations— on time, every time",
                author: "AMIT SHARMA (MD)",
                company: "Interio Craft",
                rating: 5
            },
            {
                text: "Shree Jeen Interiors is one of the most reliable execution partners we have worked with. Their ability to manage high-end showroom interiors with such precision and accountability is commendable. The team's work ethic and finishing standards truly stand out.",
                author: "Mr. HEMANT (Project Head)",
                company: "TATA GROUP",
                rating: 5
            }
        ];

        const renderStars = (rating) => {
            return [...Array(5)].map((star, index) => {
                return (
                    <i 
                        key={index}
                        className={index < rating ? "fa fa-star" : "fa fa-star-o"}
                        style={{ color: '#ffc107', fontSize: '18px', marginRight: '3px' }}
                    ></i>
                );
            });
        };

        return (
            <div className="container aboutUs-custom-top container-sm">
                <div id="#scrolly-div" className="row add-mobile-padding">
                    <div className="col-sm-6 col-md-6 mt-sm-5">
                        <div className="row mt-sm-5">
                            <div data-aos="fade-right" data-aos-duration="1000" className="col-2 col-sm-1">
                                <span><hr className="slash"></hr></span>
                            </div>
                            <div className="col-10 col-sm-11">
                                <p data-aos="fade-left" data-aos-duration="1000" className="about-topic">TESTIMONIALS</p>
                            </div>
                        </div>
                        <div className="row">
                            <p className="about-sub-topic">
                                <span style={{ color: '#2c3e50' }}>CLIENT</span> 
                                <span style={{ color: '#cd853f' }}> TESTIMONIALS</span>
                            </p>
                        </div>
                        <div className="row">
                            <div className="col-sm-8 col-md-12">
                                <p data-aos="fade-right" data-aos-duration="1000" data-aos-easing="ease-in-sine" className="about-text">
                                    Our clients' words speak louder than our promises. With over 15 years of delivering exceptional interior experiences, we've earned the trust of homeowners and businesses alike. From seamless project execution to innovative design solutions, these testimonials reflect our commitment to transforming spaces and exceeding expectations at every turn.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Testimonials Carousel */}
                    <div className="col-sm-6 col-md-6 mt-lg-5">
                        <div className="testimonials-carousel-container" data-aos="fade-left" data-aos-duration="1000">
                            <Carousel
                                showArrows={true}
                                showStatus={false}
                                showThumbs={false}
                                infiniteLoop={true}
                                autoPlay={true}
                                interval={5000}
                                stopOnHover={true}
                                swipeable={true}
                                emulateTouch={true}
                                className="testimonials-carousel"
                            >
                                {testimonialsData.map((testimonial, index) => (
                                    <div key={index} className="testimonial-slide">
                                        <div className="testimonial-card">
                                            <div className="testimonial-header">
                                                <h4 className="testimonial-label">TESTIMONIAL</h4>
                                                <div className="testimonial-rating">
                                                    {renderStars(testimonial.rating)}
                                                </div>
                                            </div>
                                            
                                            <div className="quote-icon">
                                                <i className="fa fa-quote-left"></i>
                                            </div>
                                            
                                            <p className="testimonial-text">
                                                {testimonial.text}
                                            </p>
                                            
                                            <div className="testimonial-author">
                                                <h5>— {testimonial.author}</h5>
                                                <p>{testimonial.company}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </Carousel>
                        </div>
                    </div>
                </div>

                {/* Add custom styles */}
                <style jsx>{`
                    .testimonials-carousel-container {
                        padding: 20px;
                        height: auto;
                    }

                    .testimonial-slide {
                        padding: 20px;
                        height: 450px;
                        display: flex !important;
                        align-items: center;
                        justify-content: center;
                    }

                    .testimonial-card {
                        background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
                        border-radius: 20px;
                        padding: 30px 25px;
                        text-align: center;
                        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
                        border: 2px solid #15d4c7;
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        transition: all 0.3s ease;
                        position: relative;
                    }

                    .testimonial-card:hover {
                        transform: translateY(-5px);
                        box-shadow: 0 15px 40px rgba(21, 212, 199, 0.2);
                    }

                    .testimonial-header {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-bottom: 20px;
                    }

                    .testimonial-label {
                        font-size: 12px;
                        font-weight: 700;
                        color: #15d4c7;
                        letter-spacing: 2px;
                        margin: 0;
                    }

                    .testimonial-rating {
                        display: flex;
                        gap: 2px;
                    }

                    .quote-icon {
                        font-size: 40px;
                        color: #15d4c7;
                        margin-bottom: 20px;
                        opacity: 0.7;
                    }

                    .testimonial-text {
                        font-size: 14px;
                        color: #555;
                        line-height: 1.6;
                        font-style: italic;
                        margin-bottom: 25px;
                        flex-grow: 1;
                        display: flex;
                        align-items: center;
                    }

                    .testimonial-author {
                        border-top: 1px solid #e0e0e0;
                        padding-top: 20px;
                    }

                    .testimonial-author h5 {
                        font-size: 16px;
                        font-weight: 700;
                        color: #2c3e50;
                        margin-bottom: 5px;
                    }

                    .testimonial-author p {
                        font-size: 13px;
                        color: #cd853f;
                        font-weight: 600;
                        margin: 0;
                    }

                    .testimonials-carousel .carousel .control-arrow {
                        background: #15d4c7 !important;
                        opacity: 0.8 !important;
                        border-radius: 50% !important;
                        width: 40px !important;
                        height: 40px !important;
                        top: 50% !important;
                        transform: translateY(-50%) !important;
                        display: flex !important;
                        align-items: center !important;
                        justify-content: center !important;
                        border: none !important;
                        z-index: 2 !important;
                    }

                    .testimonials-carousel .carousel .control-arrow:before {
                        border-top: 8px solid transparent !important;
                        border-bottom: 8px solid transparent !important;
                        content: '' !important;
                        margin: 0 !important;
                        position: absolute !important;
                        top: 50% !important;
                        left: 50% !important;
                        transform: translate(-50%, -50%) !important;
                    }

                    .testimonials-carousel .carousel .control-prev:before {
                        border-right: 10px solid white !important;
                        border-left: 0 !important;
                        margin-left: -2px !important;
                    }

                    .testimonials-carousel .carousel .control-next:before {
                        border-left: 10px solid white !important;
                        border-right: 0 !important;
                        margin-left: 2px !important;
                    }

                    .testimonials-carousel .carousel .control-arrow:hover {
                        opacity: 1 !important;
                        background: #0aa79d !important;
                    }

                    .testimonials-carousel .carousel .control-dots {
                        margin: 20px 0 0 0;
                    }

                    .testimonials-carousel .carousel .control-dots .dot {
                        background: #15d4c7 !important;
                        box-shadow: none;
                        width: 12px;
                        height: 12px;
                        border-radius: 50%;
                        margin: 0 6px;
                    }

                    .testimonials-carousel .carousel .control-dots .dot.selected {
                        background: #2c3e50 !important;
                    }

                    /* Enhanced Mobile Responsiveness */
                    @media (max-width: 768px) {
                        .testimonials-carousel-container {
                            padding: 10px 5px; /* Reduced padding for more width */
                            width: 100%;
                            max-width: 100%;
                            box-sizing: border-box;
                        }

                        .testimonial-slide {
                            height: 400px; /* Increased height for better content fit */
                            padding: 10px; /* Reduced padding */
                            width: 100%;
                            max-width: 100%;
                        }

                        .testimonial-card {
                            padding: 20px 15px; /* More compact padding */
                            max-width: 100%;
                            width: 100%;
                            box-sizing: border-box;
                            margin: 0 auto;
                            border-radius: 15px; /* Slightly smaller border radius */
                        }

                        .testimonial-header {
                            margin-bottom: 15px; /* Reduced margin */
                            flex-wrap: wrap; /* Allow wrapping on very small screens */
                            gap: 10px;
                        }

                        .testimonial-label {
                            font-size: 10px; /* Smaller font */
                            letter-spacing: 1px;
                        }

                        .quote-icon {
                            font-size: 28px; /* Smaller icon */
                            margin-bottom: 12px;
                        }

                        .testimonial-text {
                            font-size: 12px; /* Reduced font size for better fit */
                            line-height: 1.5;
                            margin-bottom: 15px;
                            word-wrap: break-word; /* Allow text wrapping */
                            hyphens: auto; /* Enable hyphenation */
                        }

                        .testimonial-author {
                            padding-top: 15px; /* Reduced padding */
                        }

                        .testimonial-author h5 {
                            font-size: 13px; /* Smaller font */
                            margin-bottom: 3px;
                            word-wrap: break-word;
                        }

                        .testimonial-author p {
                            font-size: 11px; /* Smaller font */
                            word-wrap: break-word;
                        }

                        .testimonial-rating {
                            gap: 1px; /* Tighter star spacing */
                        }

                        .testimonial-rating i {
                            font-size: 14px !important; /* Smaller stars */
                        }
                    }

                    /* Extra small screens (phones in portrait) */
                    @media (max-width: 480px) {
                        .testimonials-carousel-container {
                            padding: 5px 2px; /* Minimal padding */
                            margin: 0;
                        }

                        .testimonial-slide {
                            height: 380px; /* Adjusted height */
                            padding: 5px; /* Minimal padding */
                        }

                        .testimonial-card {
                            padding: 18px 12px; /* More compact padding */
                            border-radius: 12px;
                        }

                        .testimonial-header {
                            margin-bottom: 12px;
                            flex-direction: column; /* Stack header elements */
                            align-items: center;
                            gap: 8px;
                        }

                        .testimonial-label {
                            font-size: 9px;
                            text-align: center;
                        }

                        .quote-icon {
                            font-size: 24px; /* Smaller icon */
                            margin-bottom: 10px;
                        }

                        .testimonial-text {
                            font-size: 11px; /* Smaller text */
                            line-height: 1.4;
                            margin-bottom: 12px;
                            text-align: left; /* Better readability */
                        }

                        .testimonial-author h5 {
                            font-size: 12px;
                            margin-bottom: 2px;
                        }

                        .testimonial-author p {
                            font-size: 10px;
                        }

                        .testimonial-rating i {
                            font-size: 12px !important; /* Even smaller stars */
                        }
                    }

                    /* Very small screens */
                    @media (max-width: 360px) {
                        .testimonials-carousel-container {
                            padding: 2px 0; /* Minimal padding */
                        }

                        .testimonial-slide {
                            height: 350px; /* Reduced height */
                            padding: 2px;
                        }

                        .testimonial-card {
                            padding: 15px 10px; /* Very compact */
                            border-radius: 10px;
                        }

                        .testimonial-header {
                            margin-bottom: 10px;
                        }

                        .testimonial-label {
                            font-size: 8px;
                        }

                        .quote-icon {
                            font-size: 20px;
                            margin-bottom: 8px;
                        }

                        .testimonial-text {
                            font-size: 10px;
                            line-height: 1.3;
                            margin-bottom: 10px;
                        }

                        .testimonial-author {
                            padding-top: 10px;
                        }

                        .testimonial-author h5 {
                            font-size: 11px;
                        }

                        .testimonial-author p {
                            font-size: 9px;
                        }

                        .testimonial-rating i {
                            font-size: 10px !important; /* Very small stars */
                        }
                    }
                `}</style>
            </div>
        )
    };
};



